import { useAuth } from '@framework/auth';
import { HeaderRightMenu } from '@framework/ui';
import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { LanguageMenu } from './LanguageMenu';
import { MobileFullMenu } from './MobileFullMenu';
import { FrontNotificationButton } from './notification/FrontNotificationButton';
import { UserMenu } from './UserMenu';

const enableLanguageMenu = process.env.ENABLE_LOCALIZATION === 'true';

const RightSideMenuSpace = styled(Space)`
  gap: 8px;
  @media (max-width: 400px) {
    gap: 0px !important;
  }
`;

export interface RightSideMenuProps {
  extra?: React.ReactNode;
  isMobile?: boolean | null;
  /** Variante pubblica: mostra solo lo switch lingua. */
  publicOnly?: boolean;
}

export function RightMenu(props: RightSideMenuProps) {
  const { extra, isMobile, publicOnly } = props;
  const { isLogged, isPrelogged } = useAuth();
  // Durante la selezione "per conto di" (token presente ma profilo non ancora
  // scelto) nascondiamo le voci private.
  const hidePrivate = isPrelogged && !isLogged;

  // Variante pubblica: solo lo switch lingua, nessuna voce privata.
  return (
    <HeaderRightMenu>
      <RightSideMenuSpace>
        {!publicOnly && extra}
        {enableLanguageMenu && <LanguageMenu isMobile={isMobile} />}
        {!publicOnly && isLogged && <FrontNotificationButton />}
        {!publicOnly &&
          !hidePrivate &&
          (isMobile ? <MobileFullMenu /> : <UserMenu />)}
      </RightSideMenuSpace>
    </HeaderRightMenu>
  );
}
